import {
  EnvironmentProviders,
  PLATFORM_ID,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { ClarityTrackingProvider } from './providers/clarity.provider';
import { MetaPixelTrackingProvider } from './providers/meta-pixel.provider';
import { PostMessageTrackingProvider } from './providers/post-message.provider';
import { TRACKING_CONFIG, TRACKING_PROVIDERS, type TrackingConfig } from './tracking.tokens';
import { TrackingService } from './tracking.service';
import { TrackingListenerService } from './tracking-listener.service';

export function provideTracking(config: TrackingConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: TRACKING_CONFIG, useValue: config },
    { provide: TRACKING_PROVIDERS, useClass: ClarityTrackingProvider, multi: true },
    { provide: TRACKING_PROVIDERS, useClass: MetaPixelTrackingProvider, multi: true },
    { provide: TRACKING_PROVIDERS, useClass: PostMessageTrackingProvider, multi: true },
    provideAppInitializer(() => {
      const platformId = inject(PLATFORM_ID);
      const trackingService = inject(TrackingService);
      const listenerService = inject(TrackingListenerService);
      if (isPlatformBrowser(platformId)) {
        trackingService.initializeAll();
        listenerService.startListening();
      }
    }),
  ]);
}
